module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('国歌上传')))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$T('国歌上传说明')))]), _vm._v(" "), _c('el-form', {
    staticClass: "anthem-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('音频文件')
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.nationalAnthemList,
      "limit": 5,
      "accept": ".mp3,.wav,.m4a,.aac,.ogg,audio/*"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('国旗')
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.nationalFlagList,
      "limit": 3,
      "accept": "image/*"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "field-hint"
  }, [_vm._v(_vm._s(_vm.$T('国旗上传说明')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.$T('保存')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e545c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep7.vue
// module id = 1433
// module chunks = 0